import { isEmpty as emberIsEmpty } from '@ember/utils';
import { computed } from '@ember/object';
export default function isEmpty(property) {
  return computed(property, function () {
    return emberIsEmpty(this.get(property));
  });
}